import { Reveal } from "./shared";

const FIGURES = [
  { value: "99.6%", label: "Infrared blocked" },
  { value: "99%", label: "UV blocked" },
  { value: "72%", label: "Solar heat blocked" },
  { value: "Up to 19%", label: "Energy savings" },
  { value: "10+", label: "Years lifespan" },
];

export default function StatsBand() {
  return (
    <section
      data-testid="stats-band"
      className="bg-white border-b border-slate-300"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-10 md:py-14">
        <Reveal>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 border border-slate-900 bg-white">
            {FIGURES.map((f, i) => (
              <div
                key={f.label}
                data-testid={`stat-figure-${f.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`px-5 py-6 md:py-8 border-slate-900 ${
                  i < FIGURES.length - 1 ? "border-b sm:border-b-0" : ""
                } ${i % 2 === 0 ? "border-r" : ""} sm:border-r sm:last:border-r-0 lg:border-b-0 ${
                  i === FIGURES.length - 1 ? "col-span-2 sm:col-span-1" : ""
                }`}
              >
                <p className="font-mono font-semibold text-2xl md:text-3xl text-[#0284C7]">
                  {f.value}
                </p>
                <p className="mt-2 font-mono text-xs tracking-[0.18em] uppercase text-slate-500">
                  {f.label}
                </p>
              </div>
            ))}
          </div>
          <p
            data-testid="stats-band-note"
            className="mt-4 font-mono text-xs tracking-widest text-slate-400 uppercase"
          >
            * Manufacturer data · Optical performance to EN 410
          </p>
        </Reveal>
      </div>
    </section>
  );
}
